import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Post, PostPage } from '../models/post.model';
import { Category } from '../models/category.model';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PostService {
  private base = `${environment.apiUrl}/api/v1`;

  constructor(private http: HttpClient) {}

  /** Liste paginée avec filtres optionnels */
  getArticles(
    page: number = 1,
    pageSize: number = 10,
    search?: string,
    categoryId?: number,
    categorySlug?: string,
  ): Observable<PostPage> {
    let params = new HttpParams()
      .set('page', page)
      .set('per_page', pageSize);
    if (search && search.trim())   params = params.set('search', search.trim());
    if (categoryId)                params = params.set('category_id', categoryId);
    if (categorySlug && categorySlug.trim())
                                   params = params.set('category_slug', categorySlug.trim());
    return this.http.get<any>(`${this.base}/posts`, { params }).pipe(
      map(res => ({
        data:  res.data?.data ?? res.data ?? [],
        total: res.meta?.total ?? res.data?.total ?? 0,
      } as PostPage)),
    );
  }

  /** Détail par slug */
  getArticle(slug: string): Observable<any> {
    return this.http.get<any>(`${this.base}/posts/slug/${slug}`);
  }

  /** Derniers articles (raccourci) */
  getRecentArticles(n: number = 5): Observable<Post[]> {
    return this.getArticles(1, n).pipe(map(res => res.data));
  }

  /** Liste des catégories */
  getCategories(): Observable<Category[]> {
    return this.http
      .get<any>(`${this.base}/categories`)
      .pipe(map(res => res.data ?? res ?? []));
  }
}
